import styled, { css } from 'styled-components';

export const GridWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing.m};
  background-color: ${({ theme }) => theme.colors.seasalt};
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-content: center;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`;

export const GridContent = styled.div(
  ({ theme }) => css`
    padding-top: ${theme.spacing.m};
    display: grid;
    grid-template-columns: repeat(auto-fit, 30%);
    gap: ${theme.spacing.sm};
  `
);

export const GridContainer = styled.div(
  ({ height }) => css`
    max-height: ${height};
    overflow: hidden;
    transition: max-height 0.6s ease;
  `
);

export const GridItem = styled.div`
  border: ${({ theme }) => theme.colors.eerieBlack};
  text-align: center;
  border-radius: ${({ theme }) => theme.radius.m};
  display: flex;
  flex-wrap: wrap;
  position: relative;
`;

export const Thumbnail = styled.img`
  width: ${({ theme }) => theme.width.full};
  height: 100px;
  border-top-left-radius: ${({ theme }) => theme.radius.s};
  border-top-right-radius: ${({ theme }) => theme.radius.s};   
  object-fit: cover;
`;

export const TitleContent = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.s};
  align-items: baseline;
`;

export const FileNameContainer = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding: ${({ theme }) => theme.spacing.s};
  flex: 1;
  font-size: ${({ theme }) => theme.fontSize.s};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom-left-radius: ${({ theme }) => theme.radius.s};
  border-bottom-right-radius: ${({ theme }) => theme.radius.s};
`;

export const DeleteIconContainer = styled.div`
  position: absolute;
  right: ${({ theme }) => theme.spacing.xs};
  top: ${({ theme }) => theme.spacing.xs};
`;

export const AudioFileContainer = styled.div`
  width: ${({ theme }) => theme.width.full};
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: ${({ theme }) => theme.radius.s};
  border-top-right-radius: ${({ theme }) => theme.radius.s};
  background-color: ${({ theme }) => theme.colors.aquaBlue};
`;
